import { Box, Skeleton, Stack } from '@mui/material'

const CreateAppointmentNewSkeleton = () => {
  return (
    <Box>
      <Stack spacing={3}>
        <Stack spacing={3}>
          <Skeleton variant="text" width={220} height={28} />
          <Stack spacing={2}>
            <Skeleton variant="rectangular" height={56} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="rectangular" height={56} sx={{ flex: 1 }} />
            <Skeleton variant="rectangular" height={56} sx={{ flex: 1 }} />
          </Stack>
        </Stack>
        <Skeleton variant="rectangular" height={40} width={180} sx={{ position: 'fixed', bottom: 16, right: 16 }} />
      </Stack>
    </Box>
  )
}

export { CreateAppointmentNewSkeleton }
